import React, { Component } from 'react';
import { Link } from "react-router-dom";
import Fade from 'react-reveal/Fade';
import '../custom-build/steps.scss';

import buttonarrow from '../../assets/images/button-arrow.svg';
import person from '../../assets/images/person.svg';
import productionimg from '../../assets/images/production.svg';

class ProductionView extends Component {
    render() {
        return (
          <div className="home-content steps-content">
              <div className="homeleftcontent steps-left">
                <Fade right>
                    <h4>Outsource to vendor or track the order through different stages of production. CustomBuilt offers built-in workflows for various printing processes.</h4>
                </Fade>
                <Fade right><p className="steps-text">Analyze and optimize production processes to increase productivity.</p></Fade>
                    <Fade right>
                        <div className="button-section">
                            <Link to="/artworkproofing" className="theme-btn backarrow-btn"><img alt="" src={buttonarrow} /></Link>
                            <Link to="/Shipping" className="theme-btn">Shipping <img alt="" src={buttonarrow} /></Link>
                        </div>
                </Fade>
                <div className="bottom-person">
                    <Fade right>
                        <img alt="Customer Portal" src={person} />
                        <div className="person-right">
                            <h3>Order status</h3>
                            <small>Customer Portal</small>
                        </div>
                    </Fade>
                </div>
              </div>
              <div className="homerightcontent">
                  <Fade right>
                      <img alt="Custom Built" className="w-100 production-img" src={productionimg} />
                  </Fade>
              </div>
          </div>
        )
    }
}

export default ProductionView
